var MultiPathElementType;
(function (MultiPathElementType) {
    MultiPathElementType["STANDARD"] = "STANDARD";
    MultiPathElementType["STABLE_PLAIN"] = "STABLE_PLAIN";
    MultiPathElementType["STABLE_META"] = "STABLE_META";
})(MultiPathElementType || (MultiPathElementType = {}));
const isStandardMultiPathElement = (pathElement) => pathElement.type === MultiPathElementType.STANDARD;
const isStableMultiPathElement = (pathElement) => pathElement.type === MultiPathElementType.STABLE_META || pathElement.type === MultiPathElementType.STABLE_PLAIN;
const isStableMetaMultiPathElement = (pathElement) => pathElement.type === MultiPathElementType.STABLE_META;
const isStablePlainMultiPathElement = (pathElement) => pathElement.type === MultiPathElementType.STABLE_PLAIN;
export { isStableMetaMultiPathElement, isStableMultiPathElement, isStablePlainMultiPathElement, isStandardMultiPathElement, MultiPathElementType, };
//# sourceMappingURL=types.js.map